<template>
    <div class="t_search_box">
        <div class="t_search_select" style="margin-right:20px">
            <span style="color: #6D6D6D;">账号类别：</span>
            <el-select style="width: 180px;" size="small" @change="choosetype" v-model="search1"  placeholder="请选择">
                <el-option  label="资产账号" :value="1" />
                <el-option  label="客服" :value="2" />
                <el-option  label="管理员" :value="3" />
            </el-select>
        </div>
        <el-button style="margin-bottom: 10px;" color="#F1F3F9" @click="resetsearch" type="primary">重置</el-button>
    </div>
    <el-button color="#4F46E5" class="t_add_people" @click="addpart" type="primary">添加成员</el-button>
    <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.tableData" style="width: 100%">
        <el-table-column prop="peopleinfo" label="成员信息">
            <template #default="scope">
                <div class="t_head_box">
                    <!-- <img style="width:30px;height: 30px;border-radius: 50%;margin-right:5px" :src="scope.row.avatar" alt=""> -->
                    {{ scope.row.name }}
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="friendNum" label="成员客户数" />
        <el-table-column prop="activity" label="激活状态">
            <template #default="scope">
                <el-tag v-if="scope.row.status==1" type="success">已激活</el-tag>
                <el-tag v-else-if="scope.row.status==2" type="info">已禁用</el-tag>
                <div v-else-if="scope.row.status==4">
                    <el-tag type="danger">未激活</el-tag>
                    <img style="width:12px;margin-left:5px;" src="../../assets/img/tips.png" alt="">
                    <span style="color:#4F46E5;font-size: 13px;margin-left:5px">如何配置可见范围备份</span>
                </div>
                <el-tag v-else-if="scope.row.status==5" type="warning">退出企业</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="isKf" label="是否为资产账号">
            <template #default="scope">
                <span v-if="scope.row.isKf==1">是</span>
                <span v-else>否</span>
            </template>
        </el-table-column>
        <!-- <el-table-column prop="belong" label="所属管理组" /> -->
        <el-table-column prop="belong" label="操作">
            <template #default="scope">
                <el-button size="small" type="text" style="color:#4F46E5"
                    @click="peoinfo(scope.row)">成员详情</el-button>
                <el-button v-if="scope.row.isKf==0" size="small" type="text" style="color:#4F46E5"
                    @click="choosekf(scope.row)">指定为资产账号</el-button>
            </template>
        </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagechange :total="total" :nowpage="searchdata.pageNo" @page_change="page_change" />
    <!-- 添加成员弹窗 -->
    <el-dialog v-model="addwindow" title="添加成员" width="700px">
        <div class="t_addtitle">如何配置【91Fans】可见范围</div>
        <div class="t_add_tips">企业成员需配置到自建应用【91Fans提醒】的可见范围后，才可登录和使用91Fans。</div>
        <div class="t_add_step">1.登录企业微信管理后台，打开【应用管理】-【应用】-【自建】-【91Fans】</div>
        <img class="t_add_img" src="../../assets/img/add1.png" />
        <div class="t_add_step">2.点击编辑-修改可见范围为企业全员或需使用应用的成员</div>
        <img class="t_add_img" src="../../assets/img/add2.png" />
        <div class="t_add_btnbox">
            <el-button color="#4F46E5" type="primary" @click="addwindow = false">我知道了</el-button>
        </div>
    </el-dialog>
    <!-- 成员详情 -->
    <el-dialog
        v-model="infoshow"
        title="成员详情"
        width="800px"
    >
    <el-descriptions direction="vertical"
        border >
        <el-descriptions-item label="创建人">{{peoinfodata.data.createBy}}</el-descriptions-item>
        <el-descriptions-item label="开通群聊数">{{peoinfodata.data.createGroupNum}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{peoinfodata.data.createTime}}</el-descriptions-item>
        <el-descriptions-item label="性别">
            <span v-if='peoinfodata.data.gender==1'>男</span><span v-else-if='peoinfodata.data.gender==2'>女</span><span v-else-if='peoinfodata.data.gender==0'>未定义</span>
        </el-descriptions-item>
        <el-descriptions-item label="群聊数"
        >{{peoinfodata.data.groupNum}}</el-descriptions-item>
        <el-descriptions-item label="openid">
            {{peoinfodata.data.openUserid}}
    
        </el-descriptions-item>
        <el-descriptions-item label="员工个人二维码"
        >{{peoinfodata.data.qrCode}}</el-descriptions-item>
        <el-descriptions-item label="修改人"
        >{{peoinfodata.data.updateBy}}</el-descriptions-item>
        <el-descriptions-item label="修改时间"
        >{{peoinfodata.data.updateTime}}</el-descriptions-item>
    </el-descriptions>
        <!-- <div>创建人:{{peoinfodata.data.createBy}}</div>
        <div>开通群聊数:{{peoinfodata.data.createGroupNum}}</div>
        <div>创建时间:{{peoinfodata.data.createTime}}</div>
        <div>性别:<span v-if='peoinfodata.data.gender==1'>男</span><span v-else-if='peoinfodata.data.gender==2'>女</span><span v-else-if='peoinfodata.data.gender==0'>未定义</span></div>
        <div>群聊数:{{peoinfodata.data.groupNum}}</div>
        <div>openid:{{peoinfodata.data.openUserid}}</div>
        <div>员工个人二维码:{{peoinfodata.data.qrCode}}</div>
        <div>修改人:{{peoinfodata.data.updateBy}}</div>
        <div>修改时间:{{peoinfodata.data.updateTime}}</div> -->
    </el-dialog>
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { ref, reactive, provide, onBeforeMount, onMounted, watch, inject } from 'vue'
//导入子组件
import pagechange from '../pagechange.vue'
// import { peolist,peolistedit } from '@/assets/js/common.js' // work/bcDepartment* 老接口已废弃
import { useStore } from '../../store'
import { storeToRefs } from 'pinia'
const store = useStore();
const { tree_corpId ,tree_departId,tbuser} = storeToRefs(store)
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //人员列表
    getlist()
})
//搜索
//搜索1数据
const search1 = ref('')
//搜索2数据
// const search2 = ref('')
//搜索下拉数据
// const options = reactive([
//     {
//         value: 'Option1',
//         label: 'Option1',
//     },
//     {
//         value: 'Option2',
//         label: 'Option2',
//     },
//     {
//         value: 'Option3',
//         label: 'Option3',
//     },
//     {
//         value: 'Option4',
//         label: 'Option4',
//     },
//     {
//         value: 'Option5',
//         label: 'Option5',
//     },
// ])

//列表数据
const tableData = reactive({
    tableData: []
})
//添加弹窗是否显示
const addwindow = ref(false)
//打开弹窗
const addpart = () => {
    addwindow.value = true
}
//成员总数
const total = ref(0)
//切换账号类别
const choosetype = (val)=>{
    console.log(val)
    searchdata.pageNo = 1
    getlist()
}
//重置
const resetsearch = ()=>{
    searchdata.pageNo = 1
    getlist()
}
//搜索
const searchdata = reactive({
   //当前页
    pageNo:1,
    corpId:'',
    departmentId:'',
    pageSize:20,
    corpId:$cookies.get("fanscorpId")
})
//人员列表
const getlist = () => {
    // work/bcDepartment 老接口已废弃
    // peolist(_url2,searchdata).then((response) => {
    //     
    //     if (response.data.msg.code == 0) {
    //         tableData.tableData = response.data.result.records
    //         total.value = response.data.result.total
    //         
    //     }
    // })
}

//监听分页
const page_change = (val)=>{
    searchdata.pageNo = val
    //人员列表
    getlist()
}
//监听树值变化,监听同步成员
watch([tree_departId,tree_corpId,tbuser], (newnum, prevnum) => {
    // console.log(newnum)
    searchdata.corpId=newnum[1]
    searchdata.departmentId=newnum[0]
    searchdata.pageNo=1
    //人员列表
    getlist()
})

// 成员详情弹窗
const infoshow = ref(false)
//当前成员详情数据
const peoinfodata = reactive({
    data:{}
})
//打开成员详情弹窗
const peoinfo = (row)=>{
    infoshow.value=true
    peoinfodata.data=row
}
//指定客服
const choosekf = (row)=>{
    ElMessageBox.confirm(
        '是否确认指定为资产账号',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        }
    )
    .then(() => {
        // work/bcDepartment 老接口已废弃
        // peolistedit(_url2,{id:row.id,isKf:1}).then((response) => {
        //     if (response.data.msg.code == 0) {
        //         //人员列表
        //         getlist()
        //         ElMessage({
        //             type: 'success',
        //             message: '操作成功！',
        //         })
        //         
        //     }
        // })
      
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
</script>
<style scoped>


:deep(.el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

.t_head_box {
    display: flex;
    align-items: center;
}

.t_addtitle {
    text-align: center;
    color: black;
    font-weight: bold;
    font-size: 17px;
}

.t_add_tips {
    background-color: #F1F3F9;
    color: #4F46E5;
    font-size: 15px;
    text-align: center;
    padding: 20px;
    border-radius: 5px;
    margin-top: 15px;
    margin-bottom: 15px;
}

.t_add_step {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}

.t_add_img {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 15px;
    margin-bottom: 15px;
}

.t_add_btnbox {
    display: flex;
    justify-content: end;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>